import {useEnabledFeatures} from '../../hooks/use-enabled-features'

/**
 * Whether issue fields should be surfaced anywhere in this project.
 *
 * The `issue_fields` payload flag is already resolved per owner and per viewer on the server by
 * `IssueFieldsFeature.enabled?`. There is deliberately no owner type check here: this hook used to
 * also require `isOrganization`, which closed the feature off for user-owned projects no matter what
 * the server answered.
 */
export function useIssueFieldsEnabled() {
  const {issue_fields} = useEnabledFeatures()

  return Boolean(issue_fields)
}
